import { Country } from 'clients/countries';
import { useEffect, useState } from 'react';
import makeCancelablePromise from 'utils/makeCancelablePromise';
import req from 'utils/req';

const INITIAL_COUNTRIES: Country[] = [];

let cachedCountries = undefined;

const getCountries = () => {
  if (!cachedCountries) {
    return req(`${URL_API_HOST}/api/v1/countries`)
      .get()
      .then((res) => {
        cachedCountries = res;
        return res;
      });
  }
  return Promise.resolve(cachedCountries);
};

const useCountries = (): Country[] => {
  const [countries, setCountries] = useState(INITIAL_COUNTRIES);

  useEffect(() => {
    const promise = makeCancelablePromise(getCountries());
    promise.promise.then((res) => {
      setCountries(res.sort((a, b) => a.name.localeCompare(b.name)));
    });
    return promise.cancel;
  }, []);

  return countries;
};

export default useCountries;
